import { styled } from '@mui/material/styles';

export const LinkText = styled('a')(() => ({
	color: 'inherit',
	textDecoration: 'underline',
	fontWeight: 600,
	cursor: 'pointer',
}));
